import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    component: function () {
      return import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");
    },
    children: [
      {
        path: "director",
        name: "DirectorMain",
        component: function () {
          return import(/* webpackChunkName: "DirectorMain" */ "../views/director/Main.vue");
        },
      },
      {
        path: "head-teacher",
        name: "HeadTeacherMain",
        component: function () {
          return import(/* webpackChunkName: "HeadTeacherMain" */ "../views/head-teacher/Main.vue");
        },
      },
      {
        path: "teacher",
        name: "TeacherMain",
        component: function () {
          return import(/* webpackChunkName: "TeacherMain" */ "../views/teacher/Main.vue");
        },
      },
    ],
  },
  {
    path: "/miniapp",
    name: "MiniApp",
    component: function () {
      return import(/* webpackChunkName: "Layout" */ "../views/Layout.vue");
    },
    children: [
      {
        path: "/",
        name: "MiniAppMain",
        component: function () {
          return import(/* webpackChunkName: "MiniAppMain" */ "../views/MiniApp.vue");
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
